import { TableHeaderCategoryConfig } from "../../../../../components/tables/tableContext/TableContext";
import { TemperatureAlertsDataInterface } from "../../../../../redux/interfaces/raports.interface";
import { getDateAndTime } from "../../../../../utils/dateAndTime";

const statusesTypes = [
  { value: 0, label: "Creat" },
  { value: 1, label: "Rezolvat" },
];

const getStatusesTypesLabel = (status: number) => {
  const getStatus = statusesTypes.find((item) => item.value === status);
  return getStatus ? getStatus.label : "";
};

export const temperatureAlertsTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "Nr. auto",
    value: "plate",
    minW: 125,
  },
  {
    label: "Stare temperatura",
    value: "alias",
    minW: 125,
  },
  {
    label: "Temperaturi",
    value: "temperatura_punct",
    minW: 125,
  },
  {
    label: "Data aparitiei",
    value: "ts",
    minW: 125,
  },
  {
    label: "Status",
    value: "status",
    minW: 125,
    withFilter: statusesTypes,
  },
  {
    label: "Observatii",
    value: "observatii",
    minW: 125,
  },
];

export const getTemperatureAlertsTableTableData: any = (
  data: TemperatureAlertsDataInterface[],
) =>
  data?.map((item) => {
    const getTemperatureCondition = () => {
      const temperatureCondition = item.alias;

      if (temperatureCondition === "scazuta") {
        return `${temperatureCondition} ❆`;
      }
      return temperatureCondition;
    };
    const getBadgeColor = () => {
      const temperatureCondition = item.alias;
      if (temperatureCondition === "scazuta") return "#27B7F5";

      return "light-info";
    };

    return {
      id: item.id_alerta,
      crudData: item,
      data: [
        {
          title: item.plate,
        },
        {
          title: getTemperatureCondition(),
          titleStyle: {
            color: getBadgeColor(),
          },
        },

        {
          badges: [
            {
              badgeText: `Actuala: ${item.temperatura_punct} °C`,
              badgeColor: "light-danger",
            },
            {
              badgeText: `Minima: ${item.temperatura_min} °C`,
              badgeColor: "light-success",
            },
            {
              badgeText: `Maxima: ${item.temperatura_max} °C`,
              badgeColor: "light-success",
            },
          ],
        },
        {
          badges: [
            {
              badgeText: getDateAndTime(item.ts),
              badgeColor: "light-info",
            },
          ],
        },
        {
          badges: [
            {
              badgeText: getStatusesTypesLabel(item.status),
              badgeColor: item.status === 1 ? "light-success" : "light-info",
            },
          ],
        },
        {
          title: item.observatii ? item.observatii : "-",
        },
      ],
    };
  });
